
























































































































import BaseItemsPage from "../BaseItemsPage";
import CustomDetailFilter from "@/components/Custom/Statistic/CustomDetailFilter.vue";
import { CustomDetailItem } from "@/store/custom/statistic/types";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { dateFilter } from "@/utils/date-util";
import { colorClassByStatus } from "@/utils/page-utils";
import { MsgTransports } from "@/store/types";

@Component({
  components: {CustomDetailFilter},
  filters: {dateFilter},
  methods: {colorClassByStatus},
})
export default class CustomDetail extends BaseItemsPage<CustomDetailItem> {

  @Getter("customStatisticDetail") responseItems!: CustomDetailItem[];
  @Getter("isLoadingDetailStat") isLoadingDetailStat!: boolean;

  currentSort: string = "create_date";
  transport = MsgTransports.CUSTOM

  is_show_filter_additional: boolean = false;
  filterClone: any = {};
  runFilter: boolean = false;

  tableFields: string[] = this.tableFieldsDefault;

  get tableFieldsDefault(): string[] {
    return [
      'create_date', 'originator', 'recipient', 'partner',
      'service_provider', 'message', 'status', 'detail',
    ];
  }

  getData(): CustomDetailItem[] {
    return this.responseItems;
  }
}
